<script lang="ts">
    import Visibility from "./Visibility.svelte";
    import gsap from "gsap";
    import { onMount } from "svelte";
    import Gap from "./Gap.svelte";

    export let delay: number = 0;
    export let delay_each: number = 0.5;
    export let children: string = "";
    export let scale_in: boolean = false;
    export let fade_left: boolean = false;
    export let fade_right: boolean = false;
    export let fade_up: boolean = false;
    export let jump_up: boolean = false;
    export let duration: number = 0.6;

    // default
    if (!(scale_in || fade_left || fade_right || fade_up || jump_up)) {
        console.log`default anim`;
        fade_up = true;
    }

    onMount(() => {
        if (jump_up) {
            const chars = wrapper.querySelectorAll("span");
            const stagger = 0.07;
            const delay = 2;

            gsap.to(chars, {
                delay,
                stagger,
                duration,
                yPercent: 100,
                ease: "power1.inOut",
            });
            gsap.to(chars, {
                delay: delay + duration,
                stagger,
                yPercent: 0,
                duration,
                ease: "power1.inOut",
            });

            return;
        }
        const elements = [...wrapper.querySelectorAll(children || ":scope > *")];
        gsap.set(elements, {
            yPercent: fade_up ? 100 : 0,
            xPercent: fade_left ? 50 : fade_right ? -50 : 0,
            opacity: 0,
            transition: "unset",
            scale: scale_in ? 0 : 1,
        });
        gsap.to(elements, {
            stagger: (elements && delay_each) || undefined,
            duration: 1,
            yPercent: 0,
            xPercent: 0,
            scale: 1,
            opacity: 1,
            delay,
            ease: "power1.inOut",
            scrollTrigger: {
                trigger: wrapper,
                start: "200 bottom",
                // markers: true,
            },
            onStart: () => {
                console.table({ fade_left, fade_right, fade_up, scale_in });
                console.log("ypercent", fade_up ? 100 : 0);
                console.log("xpercent", fade_left ? 100 : fade_right ? -100 : 0);
            },
            onComplete: () => {
                gsap.set(elements, {
                    transition: "",
                });
            },
        });
    });

    let wrapper: HTMLElement;
</script>

<div bind:this={wrapper} class="animate">
    <slot />
</div>

<style lang="scss">
    @import "../vars.scss";
    .animate {
        // display: inline-block;
    }
</style>
